import { render, staticRenderFns } from "./CreateAssets.vue?vue&type=template&id=c4fd4c20"
import script from "./CreateAssets.vue?vue&type=script&lang=js"
export * from "./CreateAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports